import revive_payload_client_4sVQNw7RlN from "/Users/esaia/Desktop/projects/gumbati-nuxt/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Users/esaia/Desktop/projects/gumbati-nuxt/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/esaia/Desktop/projects/gumbati-nuxt/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_9gMxCtyFUG from "/Users/esaia/Desktop/projects/gumbati-nuxt/node_modules/nuxt-site-config/dist/runtime/plugins/0.siteConfig.mjs";
import payload_client_yVLowv6hDl from "/Users/esaia/Desktop/projects/gumbati-nuxt/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/Users/esaia/Desktop/projects/gumbati-nuxt/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/Users/esaia/Desktop/projects/gumbati-nuxt/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Users/esaia/Desktop/projects/gumbati-nuxt/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import i18n_Fspu1Dj02B from "/Users/esaia/Desktop/projects/gumbati-nuxt/node_modules/nuxt-site-config/dist/runtime/plugins/i18n.mjs";
import composition_sLxaNGmlSL from "/Users/esaia/Desktop/projects/gumbati-nuxt/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/Users/esaia/Desktop/projects/gumbati-nuxt/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/Users/esaia/Desktop/projects/gumbati-nuxt/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import _02_initVideoPlayer_client_0TQtUp0T2y from "/Users/esaia/Desktop/projects/gumbati-nuxt/plugins/02.initVideoPlayer.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_9gMxCtyFUG,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  i18n_Fspu1Dj02B,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  _02_initVideoPlayer_client_0TQtUp0T2y
]